/* React scheduler requires requestAnimationFrame — Chrome 20 / old IE lack it */
(function () {
  if (typeof window === "undefined") {
    return;
  }

  var w = window as {
    requestAnimationFrame?: (callback: (time: number) => void) => number;
    cancelAnimationFrame?: (id: number) => void;
    setTimeout: (fn: () => void, delay: number) => number;
    clearTimeout: (id: number) => void;
    [key: string]: unknown;
  };

  if (typeof w.requestAnimationFrame === "function" && typeof w.cancelAnimationFrame === "function") {
    return;
  }

  var vendors = ["ms", "moz", "webkit", "o"];
  var i = 0;
  for (; i < vendors.length && !w.requestAnimationFrame; i = i + 1) {
    var prefix = vendors[i];
    w.requestAnimationFrame = w[prefix + "RequestAnimationFrame"] as typeof w.requestAnimationFrame;
    w.cancelAnimationFrame =
      (w[prefix + "CancelAnimationFrame"] as typeof w.cancelAnimationFrame) ||
      (w[prefix + "CancelRequestAnimationFrame"] as typeof w.cancelAnimationFrame);
  }

  var lastTime = 0;

  if (!w.requestAnimationFrame) {
    w.requestAnimationFrame = function (callback) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = w.setTimeout(function () {
        callback(currTime + timeToCall);
      }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }

  if (!w.cancelAnimationFrame) {
    w.cancelAnimationFrame = function (id) {
      w.clearTimeout(id);
    };
  }
})();
